// import axios from "axios";
import axiosInstance from "./axiosInstance";

export interface GeneralConfigurationPayload {
  updatedBy: number;

  TOUR_TNC_Instant: string;
  TOUR_TNC_Hotel: string;
  TOUR_TNC_Miqaat: string;
  TOUR_TNC_Faiz: string;

  QARZAN_TNC_TermAndConditions: string;
  PROPERTY_AVAILABILITY_RELEASE_DAYS: string;
  PROPERTY_AVAILABILITY_RELEASE_DAYS_BY_TO_TYPE: string;
}

// Helper to get token safely
export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getGeneralConfiguration = async () => {
  try {
    const response = await axiosInstance.get("/general-master", {
      // params: {
      //   pageNo: filters.pageNo ?? 0,
      //   pageSize: filters.pageSize ?? 20,
      //   searchText: filters.searchTerm || undefined,
      // },
      headers: {
        ...getAuthHeader(),
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// export const createQarzanApplication = async (
//   payload: CreateQarzanApplicationPayload,
// ) => {
//   try {
//     const response = await axiosInstance.post("/QarzanApplication", payload, {
//       headers: {
//         ...getAuthHeader(),
//       },
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const updateGeneralConfiguration = async (
  payload: GeneralConfigurationPayload,
) => {
  try {
    const response = await axiosInstance.post("/general-master/save", payload, {
      headers: {
        ...getAuthHeader(),
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
